/**
 * Open Cookie Preference
 * default behaviour of Borlabs Cookie is to open the Cookie Preference when a link has the class "borlabs-cookie-preference"
 * but it is not possible to set a class on an inline link in the WP editor so we have to use the href attribute
 */
jQuery(document).on(
  "click",
  'a[href="#borlabs-cookie-preference"]',
  function (event) {
    event.preventDefault();
    window.BorlabsCookie.openCookiePreference();
  }
);
